import type { PaymentMethod } from '@/lib/types';

export const samplePaymentMethodsData: PaymentMethod[] = [
  // Note: Super Admin users should not have sample payment method data in production
  {
    id: 'pm_2001234567',
    userUid: '2847391650', // Roger Federer (Admin)
    type: 'Amex',
    last4: '1234',
    expiryMonth: 6,
    expiryYear: 2027,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_3001234567',
    userUid: '6182947350', // Serena Williams
    type: 'Visa',
    last4: '9876',
    expiryMonth: 3,
    expiryYear: 2026,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_4001234567',
    userUid: '9617384052', // Andy Murray
    type: 'Mastercard',
    last4: '5432',
    expiryMonth: 11,
    expiryYear: 2025,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_5001234567',
    userUid: '4051728396', // Maria Sharapova (Teacher)
    type: 'Visa',
    last4: '7890',
    expiryMonth: 9,
    expiryYear: 2026,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_5001234568',
    userUid: '4051728396', // Maria Sharapova (Teacher)
    type: 'Mastercard',
    last4: '1111',
    expiryMonth: 4,
    expiryYear: 2027,
    isDefault: false,
    provider: 'sample',
    imageUrl: undefined
  },
  
  // John McEnroe (Admin) - Global Padel Group
  {
    id: 'pm_6001234567',
    userUid: '4567891230', // John McEnroe (Admin)
    type: 'Visa',
    last4: '2468',
    expiryMonth: 10,
    expiryYear: 2026,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_6001234568',
    userUid: '4567891230', // John McEnroe (Admin)
    type: 'Amex',
    last4: '9753',
    expiryMonth: 7,
    expiryYear: 2027,
    isDefault: false,
    provider: 'sample',
    imageUrl: undefined
  },
  
  // Venus Williams (Admin) - Urban Tennis Centers
  {
    id: 'pm_7001234567',
    userUid: '5678912340', // Venus Williams (Admin)
    type: 'Mastercard',
    last4: '8642',
    expiryMonth: 5,
    expiryYear: 2026,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_7001234568',
    userUid: '5678912340', // Venus Williams (Admin)
    type: 'Visa',
    last4: '1357',
    expiryMonth: 12,
    expiryYear: 2025,
    isDefault: false,
    provider: 'sample',
    imageUrl: undefined
  },
  
  // Amélie Mauresmo (Admin) - Lagardère Paris Racing
  {
    id: 'pm_8001234567',
    userUid: '6789123450', // Amélie Mauresmo (Admin)
    type: 'Visa',
    last4: '9246',
    expiryMonth: 2,
    expiryYear: 2027,
    isDefault: true,
    provider: 'sample',
    imageUrl: undefined
  },
  {
    id: 'pm_8001234568',
    userUid: '6789123450', // Amélie Mauresmo (Admin)
    type: 'Mastercard',
    last4: '6802',
    expiryMonth: 8,
    expiryYear: 2026,
    isDefault: false,
    provider: 'sample',
    imageUrl: undefined
  }
]; 
